//document.addEventListener('touchstart', onTouchStart, {passive: true});

const divs = document.querySelectorAll('.mega-bar-link-has-children');
divs.forEach(el => el.addEventListener('click', event => {
    event.preventDefault();
}));

const menu = document.querySelector('.mobile-menu-trigger');
const menuLinks = document.querySelector('.main-menu');

// Display Mobile Menu
const mobileMenu = () => {
    menu.classList.toggle('is-active');
    menuLinks.classList.toggle('active');
};

menu.addEventListener('click', mobileMenu);




// Menu More (desktop only + optimized)
(function () {
    const DESKTOP_MQ = window.matchMedia("(min-width: 992px)"); // Bootstrap lg+
    let ro = null;
    let cleanup = null;

    function init() {
        const ul = document.querySelector("ul.main-menu");
        if (!ul) return;

        const more = ul.querySelector("#menuMore");
        if (!more) return;

        const moreBtn = more.querySelector(".menu-more-btn");
        const moreMenu = more.querySelector(".sub-menu");
        if (!moreBtn || !moreMenu) return;

        // ✅ Conteneur limite (ajuste si besoin)
        const limit = ul.closest(".col-12.col-lg-10") || ul.parentElement;
        if (!limit) return;

        const getItems = () => Array.from(ul.children).filter((li) => li !== more);

        const closeMore = () => {
            more.classList.remove("is-open");
            moreBtn.setAttribute("aria-expanded", "false");
        };

        const onBtnClick = () => {
            more.classList.toggle("is-open");
            moreBtn.setAttribute("aria-expanded", String(more.classList.contains("is-open")));
        };

        const onDocClick = (e) => {
            if (!more.contains(e.target)) closeMore();
        };

        moreBtn.addEventListener("click", onBtnClick);
        document.addEventListener("click", onDocClick);

        const resetAllFromMore = () => {
            // Remet tous les <li> depuis "Plus" dans le menu principal
            while (moreMenu.firstChild) ul.insertBefore(moreMenu.firstChild, more);
        };

        // 🔑 overflow visuel : est-ce que le dernier item dépasse le bord droit du conteneur limite ?
        const hasVisualOverflow = () => {
            const limitRight = limit.getBoundingClientRect().right;
            const items = getItems().filter((li) => li.offsetParent !== null);
            if (!items.length) return false;
            const last = items[items.length - 1];
            return last.getBoundingClientRect().right > (limitRight - 2);
        };

        const update = () => {
            // Reset : on remet tout depuis "Plus"
            resetAllFromMore();

            // On masque "Plus" puis on l'affiche pendant le calcul
            more.hidden = true;
            closeMore();
            more.hidden = false;

            // Fast path : si pas d'overflow, on cache "Plus" si vide et on sort
            if (!hasVisualOverflow()) {
                if (!moreMenu.children.length) {
                    more.hidden = true;
                    closeMore();
                }
                return;
            }

            // Tant que ça dépasse, on déplace depuis la fin
            let safety = 200;
            let items = getItems().filter((li) => li.offsetParent !== null);

            while (safety-- && items.length && hasVisualOverflow()) {
                const last = items[items.length - 1];
                if (!last) break;

                moreMenu.prepend(last);
                more.hidden = false;

                // Met à jour la liste locale (on vient d'en enlever 1)
                items.pop();
            }

            // Si rien dans "Plus" => on le cache
            if (!moreMenu.children.length) {
                more.hidden = true;
                closeMore();
            }
        };

        // ✅ Throttle avec requestAnimationFrame pour éviter les rafales ResizeObserver
        let rafId = 0;
        const scheduleUpdate = () => {
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                update();
            });
        };

        // ResizeObserver sur le conteneur + le ul (fonts, resize, sticky…)
        ro = new ResizeObserver(scheduleUpdate);
        ro.observe(limit);
        ro.observe(ul);

        window.addEventListener("load", scheduleUpdate);
        scheduleUpdate();

        // Nettoyage si on repasse en mobile
        cleanup = () => {
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = 0;
            }

            if (ro) {
                ro.disconnect();
                ro = null;
            }

            document.removeEventListener("click", onDocClick);
            moreBtn.removeEventListener("click", onBtnClick);
            window.removeEventListener("load", scheduleUpdate);

            // On remet le menu "normal"
            resetAllFromMore();
            more.hidden = false;
            closeMore();
        };
    }

    function enableIfDesktop() {
        if (DESKTOP_MQ.matches) {
            if (!cleanup) init(); // pas déjà initialisé
        } else {
            if (cleanup) {
                cleanup();
                cleanup = null;
            }
        }
    }

    // Init + écoute des changements (mobile <-> desktop)
    enableIfDesktop();
    DESKTOP_MQ.addEventListener("change", enableIfDesktop);
})();
